import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import "./Navbar.css";
import { logout } from "../api/User";
import DateTabs from "../components/DateTabs";

const Navbar = ({ sidebar, isSidebar, handleSidebar, dateFilter, setDateFilter }) => {
  const [dropdownOpenProfile, setDropdownOpenProfile] = useState(false);
  const [dropdownOpenNotification, setDropdownOpenNotification] =
    useState(false);
  const dropdownRefProfile = useRef(null);
  const dropdownRefNotification = useRef(null);
  const navigate = useNavigate();
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  useEffect(() => {
    const handleClickOutsideProfile = (event) => {
      if (
        dropdownRefProfile.current &&
        !dropdownRefProfile.current.contains(event.target)
      ) {
        setDropdownOpenProfile(false);
      }
    };
    const handleClickOutsideNotification = (event) => {
      if (
        dropdownRefNotification.current &&
        !dropdownRefNotification.current.contains(event.target)
      ) {
        setDropdownOpenNotification(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideProfile);
    document.addEventListener("mousedown", handleClickOutsideNotification);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideProfile);
      document.removeEventListener("mousedown", handleClickOutsideNotification);
    };
  }, []);

  const handleOpenLogoutDialog = () => {
    setOpenLogoutDialog(true);
  };
  const handleCloseLogoutDialog = () => {
    setOpenLogoutDialog(false);
  };
  const handleConfirmLogout = () => {
    sessionStorage.clear();
    logout();
    navigate("/");
    setOpenLogoutDialog(false);
  };

  return (
    <>
      <div
        className="container-fluid d-flex justify-content-between align-items-center px-2 hide-on-print h-15"
        style={{backgroundColor: !isSidebar ? "#151D57":"" }}
      >
        <div className={`d-flex align-items-center ${dateFilter ? 'flex-grow-1' : ''}`}>
          {/* Sidebar Toggle Button */}
          {isSidebar && (
            <button
              onClick={handleSidebar}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "8px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(0,0,0,0.05)"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
              title={sidebar ? "Collapse Sidebar" : "Expand Sidebar"}
            >
              {sidebar ? (
                <MenuOpenIcon style={{ fontSize: "24px", color: "#333" }} />
              ) : (
                <MenuIcon style={{ fontSize: "24px", color: "#333" }} />
              )}
            </button>
          )}

          {/* Date Tabs next to sidebar icon */}
          {(dateFilter && setDateFilter) && (
            <DateTabs dateFilter={dateFilter} setDateFilter={setDateFilter} />
          )}
        </div>

        <div
          className={`d-flex align-items-center justify-content-${
            !isSidebar ? "center" : "center"
          } ${!dateFilter ? 'w-100' : ''}`}
        >
          <div className="d-flex justify-content-end userName ms-3 my-2 align-items-center">
            {!isSidebar && (
              <div className="d-flex justify-content-start align-items-start" >
                <img src="logo.png" alt="" style={{ width: "3rem", height:"3rem" }} />
                <div className="mx-4">
                  <h4 className="mb-0" style={{fontWeight:"bold", color:"white"}}>
                    Department of Haryana
                  </h4>
                  <h6 className="mt-0" style={{ fontWeight:"bolder",color:"white" }}>
                    Gram Sabha Meeting Management Portal
 
                  </h6>
                </div>
              </div>
            )}
          </div>
        

          <div className="nav-item dropdown" ref={dropdownRefProfile}>
            <div
              className={`dropdown-menu user-dd animated ${
                dropdownOpenProfile ? "flipInY show" : ""
              }`}
              style={{
                display: dropdownOpenProfile ? "block" : "none",
                right: 0,
                left: "auto",
                marginTop: 50,
                paddingTop: 0,
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <button
                className="dropdown-item"
                onClick={handleOpenLogoutDialog}
              >
                Logout
              </button>
            </div>
          </div>
          <div className="nav-item dropdown" ref={dropdownRefNotification}>
            <div
              className={`dropdown-menu user-dd animated ${
                dropdownOpenNotification ? "flipInY show" : ""
              }`}
              style={{
                display: dropdownOpenNotification ? "block" : "none",
                right: "75px",
                left: "auto",
                marginTop: 50,
                paddingTop: 0,
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            ></div>
          </div>
        </div>
        <Dialog open={openLogoutDialog} onClose={handleCloseLogoutDialog}>
          <DialogTitle>
            <span style={{ color: "red", marginRight: "8px" }}>⚠️</span> Confirm
            Logout
          </DialogTitle>
          <DialogContent>Are you sure you want to log out?</DialogContent>
          <DialogActions>
            <Button onClick={handleCloseLogoutDialog} color="primary">
              Cancel
            </Button>
            <Button color="secondary" onClick={handleConfirmLogout}>
              Yes, Logout
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;
